import Calc from "./Calc";
// import CalcTitle from "./CalcTitle";

function App() {
  return (
    <div className="App">
      {/* <CalcTitle /> */}
      <Calc />
    </div>
  );
}

export default App;
